<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Storage Service - TFTP Sevice Setup</h4>
        <p>Note: To enable the TFTP Server, a storage device may be needed.</p>
        <el-form 
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable TFTP Service :">
                <el-switch v-model="flag"  @change="changes" ></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      flag: false,
      isFountUsb: false
    };
  },
  methods: {
    ajaxrequesthttp() {
      let postdata = {
        CmdType: "GET_TFTP"
      };
      this.loading = true;
      axios.post("/boafrm/fhFromTFTP", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data == "undefined" || data == "" || data.ret == "-1") {
          this.$message.error("Data acquisition failure!");
          return;
        }
        this.isFountUsb = data.isFountUsb;
        if (data.tftpSwitch == 1) {
          this.flag = true;
        } else {
          this.flag = false;
        }
      });
    },
    changes() {
      if (this.flag == true) {
        if (!this.isFountUsb) {
          this.flag = false;
          this.$message.error("Did not find USB device, can not Enable!");
          return;
        }
      }
    },
    save() {
      if (this.flag == false) {
        var tftpSwitch = 0;
      } else {
        var tftpSwitch = 1;
      }
      let postdata = {
        CmdType: "SET_TFTP",
        tftpSwitch: tftpSwitch
      };
      this.loading = true;
      axios.post("/boafrm/fhFromTFTP", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data.ret == "0") {
          this.$message.success("Configuration is successful！");
        } else {
          this.$message.error("Configuration failed!");
        }
      });
    }
  },
  created() {
    this.ajaxrequesthttp();
  }
};
</script>



